// constants/codRules.ts — Aturan COD berbasis ongkir ASLI (MODE DROPDOWN + WIZARD).
// Disepakati 2026-09-29 + koreksi 2026-11-04: COD tersedia hanya jika ongkir ASLI
// (sebelum subsidi) <= Rp30.000. Subsidi yang menekan final di bawah ambang TIDAK
// boleh membuka COD kembali. Cek = MAX(final, asli). Di atas itu → COD
// disembunyikan, customer hanya bisa Transfer/QRIS/Duitku. Wizard step 2-3 =
// checkout lengkap seperti dropdown, jadi ikut aturan yang sama. Mode lain
// (flat_regular/none/simple/javaOnly) TIDAK tersentuh. Blokir zona Z5/Z6 (adZones)
// tetap berlaku terpisah.
export const DEFAULT_COD_MAX_SHIPPING = 30000;
export const COD_MAX_SHIPPING_COST = DEFAULT_COD_MAX_SHIPPING;

export function effectiveCodShipping(
    shippingCost: unknown,
    shippingOriginalCost?: unknown,
): number {
    return Math.max(Number(shippingCost) || 0, Number(shippingOriginalCost) || 0);
}

export function isCodBlockedByShipping(
    shippingCost: unknown,
    addressInputMode?: string | null,
    maxShipping: number = DEFAULT_COD_MAX_SHIPPING,
    shippingOriginalCost?: unknown,
): boolean {
    if (addressInputMode !== 'dropdown' && addressInputMode !== 'wizard') return false;
    return effectiveCodShipping(shippingCost, shippingOriginalCost) > maxShipping;
}

export function resolveCodShippingLimit(cod: { maxShippingForCOD?: number; codShippingLimitEnabled?: boolean } | null | undefined): { enabled: boolean; max: number } {
    const enabled = cod?.codShippingLimitEnabled !== false;
    return { enabled, max: enabled ? (cod?.maxShippingForCOD ?? DEFAULT_COD_MAX_SHIPPING) : Infinity };
}
